module.exports = __webpack_public_path__ + "img/cst_cha_aranessa_saltspite_0.75bee14e.png";